import { SVGProps } from 'react';
import { COLORS } from '../../constants';

const InnowiseIcon = ({
  color = COLORS.BLACK_TITLE,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width="213"
    height="38"
    viewBox="0 0 213 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.323242 7.60449H6.81936V29.1895H0.323242V7.60449Z"
      fill={color}
    />
    <path
      d="M35.7487 16.8053V29.1507H29.2526V17.7371C29.2526 14.2431 27.558 12.6126 24.6932 12.6126C21.5864 12.6126 19.3269 14.476 19.3269 18.397V29.0731H12.8711V7.48807H19.0444V10.0115C20.7794 8.14804 23.4424 7.13867 26.4686 7.13867C31.7946 7.25514 35.7487 10.2444 35.7487 16.8053Z"
      fill={color}
    />
    <path
      d="M64.7998 16.8053V29.1507H58.3037V17.7371C58.3037 14.2431 56.6091 12.6126 53.7443 12.6126C50.5971 12.6126 48.378 14.476 48.378 18.397V29.0731H41.8818V7.48807H48.0552V10.0115C49.7901 8.14804 52.4532 7.13867 55.4793 7.13867C60.8053 7.25514 64.7998 10.2444 64.7998 16.8053Z"
      fill={color}
    />
    <path
      d="M70.7305 18.3968C70.7305 11.8747 75.9354 7.25488 83.0368 7.25488C90.1785 7.25488 95.3027 11.8747 95.3027 18.3968C95.3027 24.9189 90.1785 29.5387 83.0368 29.5387C75.9758 29.4999 70.7305 24.88 70.7305 18.3968ZM88.7663 18.3968C88.7663 14.6699 86.305 12.457 83.0368 12.457C79.7685 12.457 77.3073 14.7087 77.3073 18.3968C77.3073 22.0849 79.8089 24.3365 83.0368 24.3365C86.3454 24.3365 88.7663 22.0849 88.7663 18.3968Z"
      fill={color}
    />
    <path
      d="M137.427 7.60449L129.317 29.1895H123.063L118.06 15.8347L112.855 29.1895H106.601L98.5312 7.60449H104.664L109.99 22.2015L115.478 7.60449H120.965L126.291 22.2015L131.738 7.60449H137.427Z"
      fill={color}
    />
    <path d="M142.39 7.60449H148.886V29.1895H142.39V7.60449Z" fill={color} />
    <path
      d="M154.212 27.1317L156.391 22.6284C158.368 23.8707 161.394 24.7248 164.138 24.7248C167.123 24.7248 168.294 23.9483 168.294 22.7448C168.294 19.212 154.736 22.7837 154.736 14.204C154.736 10.0889 158.61 7.25488 165.146 7.25488C168.253 7.25488 171.642 7.91486 173.781 9.15716L171.602 13.5829C169.383 12.4182 167.164 11.9523 165.106 11.9523C162.201 11.9523 160.95 12.8452 160.95 13.9711C160.95 17.698 174.507 14.0875 174.507 22.5507C174.507 26.5494 170.634 29.4222 163.936 29.4222C160.183 29.4999 156.35 28.4905 154.212 27.1317Z"
      fill={color}
    />
    <path
      d="M202.267 20.1052H185.321C185.967 22.7839 188.307 24.4144 191.736 24.4144C194.117 24.4144 195.812 23.7545 197.345 22.3181L200.774 25.9285C198.676 28.219 195.569 29.4225 191.535 29.4225C183.788 29.4225 178.744 24.7638 178.744 18.2806C178.744 11.8361 183.868 7.13867 190.728 7.13867C197.345 7.13867 202.388 11.4091 202.388 18.3194C202.388 18.9405 202.267 19.6005 202.267 20.1052ZM185.24 16.4559H196.255C195.771 13.6996 193.673 11.9526 190.768 11.9526C187.782 12.0302 185.684 13.6996 185.24 16.4559Z"
      fill={color}
    />
    <path
      d="M209.006 7.52653C211.034 7.52653 212.677 5.94485 212.677 3.99374C212.677 2.04263 211.034 0.460938 209.006 0.460938C206.978 0.460938 205.334 2.04263 205.334 3.99374C205.334 5.94485 206.978 7.52653 209.006 7.52653Z"
      fill="#C63031"
    />
  </svg>
);

export default InnowiseIcon;
